import { GalleryItemLike, GalleryLayout } from './buildSections'

/**
 * Absolute y of the row containing the given photo, in gallery-container coordinates.
 * Layout offsets are deterministic (computed from known dimensions, no image reflow),
 * so prepend/trim scroll compensation can be exact: scrollBy(newOffset - prevOffset).
 */
export const computeAnchorOffset = <T extends GalleryItemLike>(
  layout: GalleryLayout<T>,
  anchorPhotoId: string
): number | null => {
  for (const section of layout.sections) {
    for (const row of section.rows) {
      if (row.tiles.some((tile) => tile.item.id === anchorPhotoId)) return row.top
    }
  }
  return null
}

/**
 * Scroll delta to keep anchorPhotoId visually still after the photos array changed
 * (prepend or top-trim). Null when no shared anchor exists (e.g. far jump) — then no
 * compensation should happen.
 */
export const computeAnchorDelta = <T extends GalleryItemLike>(
  prevLayout: GalleryLayout<T>,
  nextLayout: GalleryLayout<T>,
  anchorPhotoId: string
): number | null => {
  const prevOffset = computeAnchorOffset(prevLayout, anchorPhotoId)
  const nextOffset = computeAnchorOffset(nextLayout, anchorPhotoId)
  if (prevOffset === null || nextOffset === null) return null
  return nextOffset - prevOffset
}
